/**
 * Demo payload for "Load Sample" feature.
 * Realistic, complete FortiGate 60F configuration that exercises every block
 * of the FortiOS generator (greenfield purge, WAN1 DHCP + WAN2 static, LACP,
 * 4 VLANs with DHCP, management network on LAG).
 *
 * Shape matches `wizardStore.getPayload()` for clean `loadSavedConfig()` round-trip.
 */
export const DEMO_PAYLOAD = {
    currentStep: 4,
    tenant_id: "demo",
    config_id: null,

    // Group 1 — Hardware/Base
    vendor: "fortinet",
    modello: "60F",
    hostname: "forefront-demo-fw",
    password_admin: "Demo#2026",
    timezone_id: "28",
    mgmt_port: "internal1",
    mgmt_ip: "172.16.99.1",
    mgmt_subnet: "255.255.255.0",
    dns_primary: "8.8.8.8",
    dns_secondary: "1.1.1.1",
    pfsense_interface_prefix: "igb",
    pfsense_port_count: 4,
    pfsense_custom_ports: [],

    // Greenfield
    destroy_switch: true,
    remove_dhcp: true,
    disable_fortilink: true,

    // Group 2 — Topology
    wan1: {
        enabled: true,
        type: "dhcp",
        physical_port: "wan1",
        is_vlan: false,
        vlan_id: "",
        ip: "",
        gateway: "",
        subnet: "",
        username: "",
        password: "",
    },
    wan2: {
        enabled: true,
        type: "static",
        physical_port: "wan2",
        is_vlan: false,
        vlan_id: "",
        ip: "5.5.5.2",
        gateway: "5.5.5.1",
        subnet: "255.255.255.252",
        username: "",
        password: "",
    },
    wan1_vlan_error: null,
    wan2_vlan_error: null,

    lacp_aggregates: [
        {
            name: "agg1",
            member_ports: ["internal2", "internal3"],
            has_native_ip: false,
            native_ip: "",
            native_subnet: "",
        },
    ],

    vlans: [
        {
            nome_vlan: "Staff",
            vlan_id: "10",
            network_ip: "172.16.10.0",
            gateway_ip: "172.16.10.1",
            subnet_mask: "255.255.255.0",
            enable_dhcp: true,
            dhcp_start: "172.16.10.100",
            dhcp_end: "172.16.10.200",
            dns_primary: "8.8.8.8",
            dns_secondary: "1.1.1.1",
            porte_assegnate: ["internal4"],
            vlan_type: "corporate",
        },
        {
            nome_vlan: "VoIP",
            vlan_id: "20",
            network_ip: "172.16.20.0",
            gateway_ip: "172.16.20.1",
            subnet_mask: "255.255.255.0",
            enable_dhcp: true,
            dhcp_start: "172.16.20.100",
            dhcp_end: "172.16.20.200",
            dns_primary: "8.8.8.8",
            dns_secondary: "1.1.1.1",
            porte_assegnate: ["internal5"],
            vlan_type: "corporate",
        },
        {
            nome_vlan: "Guest",
            vlan_id: "50",
            network_ip: "172.16.50.0",
            gateway_ip: "172.16.50.1",
            subnet_mask: "255.255.255.0",
            enable_dhcp: true,
            dhcp_start: "172.16.50.100",
            dhcp_end: "172.16.50.200",
            dns_primary: "1.1.1.1",
            dns_secondary: "8.8.8.8",
            porte_assegnate: ["a"],
            vlan_type: "guest",
        },
        {
            nome_vlan: "IoT",
            vlan_id: "60",
            network_ip: "172.16.60.0",
            gateway_ip: "172.16.60.1",
            subnet_mask: "255.255.255.0",
            enable_dhcp: true,
            dhcp_start: "172.16.60.100",
            dhcp_end: "172.16.60.200",
            dns_primary: "1.1.1.1",
            dns_secondary: "1.0.0.1",
            porte_assegnate: ["b"],
            vlan_type: "iot",
        },
    ],

    managementNetwork: {
        enabled: true,
        ipAddress: "172.16.99.1",
        subnetMask: "255.255.255.0",
        dhcpEnabled: true,
        dhcpStart: "172.16.99.100",
        dhcpEnd: "172.16.99.200",
        interface: "agg1",
    },

    // Group 3 — Services/Policies (kept minimal for Phase 4; Phase 5 fills these)
    policies: [],
    policy_config: {},
    webfilter_config: {
        block_adult: true,
        block_malicious: true,
        block_social: false,
        block_gambling: true,
        block_proxy: true,
    },
    outbound_services: {
        http: true,
        https: true,
        dns: true,
        imaps: true,
        smtps: true,
        ftp: false,
        ntp: true,
        iot_cloud: true,
    },
    cloud_services_mapping: {},
    smart_policies: {
        policy_allow_printers: false,
        policy_allow_casting: false,
        policy_admin_omnipresence: false,
        policy_voip_outbound: true,
        policy_vendor_ot: false,
        policy_block_high_risk: true,
        policy_isolate_guest: true,
    },
    app_reachability: {
        enabled: true,
        rules: [
            { appId: "tiktok",  blocked_vlans: ["10"], allowed_vlans: [] },
            { appId: "netflix", blocked_vlans: ["10", "50"], allowed_vlans: [] },
        ],
    },

    // Group 4 — Switch (unused)
    switchVendor: null,
    switchModel: null,
    switchLacpPorts: [],
    switchPortVlans: {},

    generated_script: "",
};

export const DEMO_BACKUP_PREFIX = "Backup before demo";
